import React, { useContext, useState } from 'react';
import { View, Pressable } from 'react-native';
import { useQuery, gql } from '@apollo/client';

import ClientContext from 'app/src/contexts/ClientContext';
import { Text, Subtitle } from 'app/src/styles';
import { Link } from 'app/src/utils/routing';

import { Menu } from './DataChecks';
import { Step } from '../elements';

const ALERTS_DOCUMENTATION = gql`
  query AlertsDocumentation {
    alertsDocumentation {
      name
      path
      documentation
    }
  }
`;

const AlertsDocs = () => {
  const { isMobile } = useContext(ClientContext);

  const [selectedName, setSelectedName] = useState();

  const { data } = useQuery(ALERTS_DOCUMENTATION);

  const selectedAlert = (data && selectedName) ? (
      data.alertsDocumentation
        .find(alert => alert.name === selectedName)
    ) : null;

  const sorted = data ?
    [...data.alertsDocumentation].sort((a, b) => (
      a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1)
    ): [];

  return (
    <View style={isMobile ? {} : { flexDirection: 'row' }}>
      <Menu isMobile={isMobile}>
        <Pressable key="root" onPress={() => setSelectedName(null)}>
          <Subtitle style={{ marginTop: 0 }}>Alerts</Subtitle>
        </Pressable>

        <Link to="/how-to">
          <Text>⤆ Back</Text>
        </Link>

        {sorted?.map(alert => (
          <Pressable
            key={alert.name}
            onPress={() => setSelectedName(alert.name)}
          >
            <Text>{alert.name}</Text>
          </Pressable>
        ))}
      </Menu>

      <View style={{ flex: 1 }}>
        {selectedAlert ? (
          <>
            <Subtitle>{selectedAlert.name}</Subtitle>
            <Text style={{ marginBottom: 10}}>Path: {selectedAlert.path}</Text>
            <Text>{selectedAlert.documentation}</Text>
          </>
        ) : (
          <View style={{ gap: 10 }}>
            <Text>
              This page covers alerts that aren't due to automated data checks.
              They are often triggered by some action a user has taken, and
              posts to the November Systems slack, to either the tag-data or
              the tag-alert channel. Some alerts are triggered by scheduled
              jobs (particularly related to stripe subscriptions and data
              submission to SOK).
            </Text>

            <Step>
              Posts to tag-alert imply something needs to be done. The links in
              the menu of this page can take you to more information with
              details of what to do.
            </Step>

            <Step>
              Posts to tag-data can usually be ignored. They could indicate a
              problem if they show something unexpected or have a high
              frequency and that's generally why Jared has added them.
            </Step>
          </View>
        )}
      </View>
    </View>
  );
};

export default AlertsDocs;
